import { buildModelManager } from "../builder.js";
const DefaultConversationArchiveSelection = {
  __typename: true,
  id: true,
  accessCount: true,
  archivedAt: true,
  assistantId: true,
  createdAt: true,
  expiresAt: true,
  fullTranscript: true,
  isExpired: true,
  lastAccessedAt: true,
  messageCount: true,
  originalThreadId: true,
  summary: { markdown: true, truncatedHTML: true },
  tags: true,
  title: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "conversationArchive";
const pluralModelApiIdentifier = "conversationArchives";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultConversationArchiveSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultConversationArchiveSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultConversationArchiveSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultConversationArchiveSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultConversationArchiveSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultConversationArchiveSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultConversationArchiveSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createConversationArchive",
    operationReturnType: "CreateConversationArchive",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      conversationArchive: { required: false, type: "CreateConversationArchiveInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultConversationArchiveSelection
  },
  {
    type: "action",
    operationName: "bulkCreateConversationArchives",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateConversationArchivesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultConversationArchiveSelection
  },
  {
    type: "action",
    operationName: "updateConversationArchive",
    operationReturnType: "UpdateConversationArchive",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      conversationArchive: { required: false, type: "UpdateConversationArchiveInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultConversationArchiveSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateConversationArchives",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateConversationArchivesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultConversationArchiveSelection
  },
  {
    type: "action",
    operationName: "deleteConversationArchive",
    operationReturnType: "DeleteConversationArchive",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteConversationArchives",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertConversationArchive",
    operationReturnType: "UpsertConversationArchive",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      conversationArchive: { required: false, type: "UpsertConversationArchiveInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateConversationArchiveResult": { hasReturnType: false },
      "... on UpdateConversationArchiveResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultConversationArchiveSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertConversationArchives",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertConversationArchivesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultConversationArchiveSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "conversationArchiveGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ConversationArchiveManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultConversationArchiveSelection,
  operations
);
export {
  ConversationArchiveManager,
  DefaultConversationArchiveSelection
};
//# sourceMappingURL=ConversationArchive.js.map
